import { Component,Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PolicyXML, State, Operation, Feature } from 'src/app/models/common'
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StateReorderComponent } from './state-reorder/state-reorder.component';

@Component({
  selector: 'app-select-states-modal',
  templateUrl: './select-states-modal.component.html',
  styleUrls: ['./select-states-modal.component.scss']
})
export class SelectStatesModalComponent implements OnInit {
  @Input() public Content: any;
  Dirty:boolean=false;
  selectStates: boolean = true;
  states: State[] = [];
  policy: PolicyXML;
  action: Subject<any> = new Subject();
  statesForm = new UntypedFormGroup({
    reviewOngoing: new UntypedFormControl(true),
    accepted: new UntypedFormControl(true),
    processing: new UntypedFormControl(true),
    state: new UntypedFormControl(false)
  });
  selectedStates: State[] = [];
  rejectOp:boolean=false;
  onholdOp:boolean=false;
  discardedOp:boolean=false;
  withdrawOp:boolean=false;
  //statesList: any = [];
  constructor(public modalRef: NgbActiveModal, private modalService: NgbModal, private commonService: CommonService) {
  }

  ngOnInit() {
    this.states=this.Content.states;
     ;
    this.selectStates = true;
    //this.Content.statesList = ["Draft", "Submitted", "Review Ongoing", "Accepted", "Closed"];
    this.CheckOperations();
  }

  SaveStates(){
    let counter=1;
    var checkinactiveState=this.Content.states.filter((item)=>{
       return item.RecordStatus == "Inactive" && item.ISCHECKED==true
    });
    if(checkinactiveState!=null && checkinactiveState!=undefined && checkinactiveState.length>0){
      this.commonService.ValidationBanner("Please remove inactive state(s) to save the details");
      return false;
    }
    if(this.Content.states!=null && this.Content.states!=undefined)
    {
      counter=this.Content.states.length+1;
    }
      this.Content.states.forEach((item,index)=>{
        item.SNO=(index+1);
        if(item.NAME.toLowerCase()=="close" || item.NAME.toLowerCase()=="closed")
        {
          item.SNO=counter;
        }
      });
     
      this.modalRef.close(this.states);
  }

  listSorted(event:any){
  }

  close() {
    this.canExit().then(x=>{
      this.modalRef.dismiss();
    });
  }

  validate(states:State[]):boolean {
    var result= true;
    var iCount = states.length;
    var draft = false;
    var submit = false;
    var close = false;
    for (var i = 0; i < iCount; i++) {
      switch (states[i].NAME) {
        case "Draft":
          draft = true;
          break;
        case "Submitted":
          submit = true;
          break;
        case "Closed":
          close = true;
          break;
      }

    }
    if (!draft) {
      this.commonService.ValidationBanner("Draft state is mandatory, Please select");
//      this.modalService.show(MessageBoxComponent, { data: { heading: 'Error', content: { heading: '', description: "Draft state is mandatory, Please select." } } });
      return false;
    }

    if (!submit) {
      this.commonService.ValidationBanner("Submit state is mandatory, Please select");
   //   this.modalService.show(MessageBoxComponent, { data: { heading: 'Error', content: { heading: '', description: "Submit state is mandatory, Please select." } } });
      return false;
    }


    if (!close) {
      this.commonService.ValidationBanner("Close state is mandatory, Please select");
//      this.modalService.show(MessageBoxComponent, { data: { heading: 'Error', content: { heading: '', description: "Close state is mandatory, Please select." } } });
      return false;
    }

    return result;
  }


  checkDrafandCloseStates(states: State[]): boolean {
    var result = true;
    var iCount = states.length;
    var draft = false;
    var close = false;
    if (this.states[0].NAME != "Draft") {
      this.commonService.ValidationBanner("Draft must be Starting State, Please arrange");
//      this.modalService.show(MessageBoxComponent, { data: { heading: 'Error', content: { heading: '', description: "Draft must be Starting State, Please arrange." } } });
      return false;
    }

    if (this.states[iCount - 1].NAME != "Closed") {
      this.commonService.ValidationBanner("Close must be End State, Please arrange");
//      this.modalService.show(MessageBoxComponent, { data: { heading: 'Error', content: { heading: '', description: "Close must be End State, Please arrange." } } });
      return false;
    }
    return result;
  }

  CheckOperations() {

    if (this.Content.states.some(x => (x.NAME === "Reject" || x.NAME ==="Rejected") && x.ISCHECKED==true)) {
      this.rejectOp = true;
    }
    else {
      this.rejectOp = false;
    }

    if (this.Content.states.some(x => (x.NAME === "On-Hold" ||x.NAME=="Onhold") && x.ISCHECKED==true)) {
      this.onholdOp = true;
    }
    else {
      this.onholdOp = false;
    }

    if (this.Content.states.some(x => x.NAME === "Discard" && x.ISCHECKED==true)) {
      this.discardedOp = true;
    }
    else {
      this.discardedOp = false;
    }


    if (this.Content.states.some(x => (x.NAME === "Withdraw" ||x.NAME === "Withdrawn") && x.ISCHECKED==true)) {
      this.withdrawOp = true;
    }
    else {
      this.withdrawOp = false;
    }
  }
  ChangeOperation() {
    this.Dirty=true;
    if (this.rejectOp) {
      this.Content.states.map((person) => {
        if(person.NAME=="Rejected" || person.NAME=="Reject")
        {
          person.ISCHECKED=true;
        }
      });

    }
    else {
      this.rejectOp = false;
      this.Content.states.map((person) => {
        if(person.NAME=="Rejected" || person.NAME=="Reject")
        {
          person.ISCHECKED=false;
        }
      });
    }

    if (this.onholdOp) {
      this.Content.states.map((person) => {
        if(person.NAME=="On-Hold" || person.NAME=="Onhold")
        {
          person.ISCHECKED=true;
        }
      });
    }
    else {
      this.onholdOp = false;
      this.Content.states.map((person) => {
        if(person.NAME=="On-Hold" || person.NAME=="Onhold")
        {
          person.ISCHECKED=false;
        }
      });
    }

    if (this.discardedOp) {
      this.Content.states.map((person) => {
        if(person.NAME=="Discard" || person.NAME=="Discard")
        {
          person.ISCHECKED=true;
        }
      });
    }
    else {
      this.discardedOp = false;
      this.Content.states.map((person) => {
        if(person.NAME=="Discard" || person.NAME=="Discard")
        {
          person.ISCHECKED=false;
        }
      });
    }


    if (this.withdrawOp) {
      this.Content.states.map((person) => {
        if(person.NAME=="Withdrawn" || person.NAME=="Withdraw")
        {
          person.ISCHECKED=true;
        }
      });
    }
    else {
      this.withdrawOp = false;
      this.Content.states.map((person) => {
        if(person.NAME=="Withdrawn" || person.NAME=="Withdraw")
        {
          person.ISCHECKED=false;
        }
      });
    }

  }

  ChangeState()
  {
    this.Content.states.forEach((ditem)=>{
      if(ditem.ISCHECKED==false){
        ditem.IsReviwAvailable=false;
      }
    });
    this.Dirty=true;
  }

  canExit() {
    if (this.Dirty) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

  ReorderSate()
  {
    let modalRef = this.modalService.open(StateReorderComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: '',
      Data: this.Content.states
    }
    modalRef.result.then((result) => {
      this.Content.states=result;
    });
  }
}
